import React from 'react';

import { Button, Icon } from '@chakra-ui/react';
import { FiBookOpen } from 'react-icons/fi';

/**
 * On screens too small for the panel, a floating button back to the guide,
 * at the section the reader left.
 */
export const DocsPanelGuideChip = ({ onClick }: { onClick: () => void }) => (
  <Button
    position="fixed"
    right={6}
    bottom={6}
    zIndex={1400}
    size="sm"
    borderRadius="full"
    colorScheme="purple"
    bg="primary"
    boxShadow="lg"
    leftIcon={<Icon as={FiBookOpen} />}
    onClick={onClick}
  >
    Back to guide
  </Button>
);
